import { FC } from 'react';
import { Label } from '@atlaskit/form';
import { Jast } from '@atlassianlabs/jql-ast/dist/types/types/ast/query';
import { JQLEditorForge } from '@atlassianlabs/jql-editor-forge';

import { JqlEditorWrapper } from '../styled';

type Props = {
    onChange: (value: string, isJqlValid: boolean) => void;
    value: string;
    label?: string;
};

export const JqlField: FC<Props> = ({ onChange, value, label }) => {
    const handleValueChange = (jql: string, jast: Jast) => onChange(jql, !jast.errors.length);

    return (
        <JqlEditorWrapper>
            {label && <Label htmlFor='mlv-field-jql'>{label}</Label>}
            <JQLEditorForge
                query={value || ''}
                locale={'en'}
                onUpdate={handleValueChange}
                onSyntaxHelp={event => {
                    event.preventDefault();
                    return true;
                }}
                enableRichInlineNodes
            />
        </JqlEditorWrapper>
    );
};
